export const SIGNAL_VALUES_COLOR = [
  {
    background: '#FCECEA',
    color: '#F29B95',
    textColor: '#D83F3D'
  },
  {
    background: '#FFF8E1',
    color: '#FFE082',
    textColor: '#FF9000',
  },
  {
    background: '#E8F4F1',
    color: '#6FCDD2',
    textColor: '#218B8F'
  },

  {
    background: '#FFF8E1',
    color: '#FFE082',
  },

  {
    background: '#FCECEA',
    color: '#F29B95',
  },
]
// L, mL, O, mH, H
export const signalColorsByLetter:any = {
  R: {
    background: '#FCECEA',
    color: '#F29B95',
    textColor: '#D83F3D',
    name: 'R',
    shortName1: 'L',
    shortName2: 'H'
  },
  G: {
    background: '#E8F4F1',
    color: '#6FCDD2',
    textColor: '#218B8F',
    name: 'G',
    shortName1: 'O',
    shortName2: 'O',
  },
  A: {
    background: '#fffaee',
    color: '#ffca1c',
    textColor: '#FF9000',
    name: 'A',
    shortName1: 'mL',
    shortName2: 'mH'
  },
}

export const SCALE_TYPE_COLORS: { [type: string]: any } = {
  R: {
    background: '#FCECEA',
    color: '#E96863',
    name: 'R',
    shortName1: 'L',
    shortName2: 'H'
  },
  A: {
    background: '#FFF8E1',
    color: '#FFC107',
    name: 'A',
    shortName1: 'mL',
    shortName2: 'mH'
  },
  G: {
    background: '#E8F4F1',
    color: '#3BAAB0',
    name: 'G',
    shortName1: 'O',
    shortName2: 'O',
  },
}
